import React from 'react';
import { 
  Box, 
  Container, 
  Typography, 
//  Grid, 
  Paper, 
  Button, 
  Stepper, 
  Step, 
  StepLabel, 
  StepContent,
  useTheme,
  useMediaQuery
} from '@mui/material';

interface ProcessStep {
  label: string;
  description: string;
}

export const HowProcessWorks: React.FC = () => {
  const steps: ProcessStep[] = [
    {
      label: "Get Started Easily",
      description: "Fill out our contact form and a Massive Bio team member will reach out to you.",
    },
    {
      label: "Data Collection",
      description: "Massive Bio collects your medical records securely.",
    },
    {
      label: "Pre Screening",
      description: "Massive Bio's expert nurses check clinical trials and contact you.",
    },
    {
      label: "Concierge Services",
      description: "Massive Bio's team supports you with appointments, travel, and accommodation.",
    },
    // {
    //   label: "Enroll and Get Support",
    //   description: "If you enroll in a clinical trial, Massive Bio’s team will help you set up appointments, communicate with doctors, and more.  They’ll be by your side throughout the process.",
    // },
  ];
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));
  return (
        <>
    
      {/* How the Process Works? */}
      <Typography 
        variant="h5" 
        sx={{ 
          fontWeight: 'bold', 
          mb: 2, 
          mt: 0 ,
          // backgroundColor: 'darkblue',
          // color: 'white',
          borderRadius: 2,
          p: 2
        }}
      >
        How the Process Works?
      </Typography>
      <Box sx={{  mb: 4 }}>
        <Stepper orientation="vertical">
          {steps.map((step, index) => (
            <Step key={step.label} active={true}>
              <StepLabel 
                StepIconComponent={() => (
                  <Box
                    sx={{
                      width: 24,
                      height: 24,
                      borderRadius: '50%',
                      backgroundColor: '#5468FF',
                      color: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontWeight: 'bold',
                      fontSize: '12px',
                    }}
                  >
                    {index + 1}
                  </Box>
                )}
              >
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', fontSize: { xs: 16, sm: 16, md: 18 } }}>
                  {step.label}
                </Typography>
              </StepLabel>
              <StepContent>
                <Typography variant="body2" sx={{fontSize: { xs: 16, sm: 16, md: 18 }, mt: 2}}>{step.description}</Typography>
                {/* {(index === 0 && !isMdUp )&& (
                  <Button 
                    variant="contained" 
                    sx={{ 
                      mt: 2, 
                      backgroundColor: "#5468FF",
                      borderRadius: 10,
                      textTransform: 'none',
                      px: 3
                    }}
                    onClick={() => {
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                    }}
                  >
                    Sign Up
                  </Button>
                )} */}
              </StepContent>
            </Step>
          ))}
        </Stepper>
      </Box>

    
  </>
  );
};

//export default ClinicalTrialsInfo;